export const isOciCookieName = 'vsf-oci';
export const ociParamsCookieName = 'vsf-oci-params';
export const tokenCookieName = 'vsf-customer';